import { render, staticRenderFns } from "./FilterHeader.vue?vue&type=template&id=37ed7c2b&scoped=true"
import script from "./FilterHeader.vue?vue&type=script&lang=js"
export * from "./FilterHeader.vue?vue&type=script&lang=js"
import style0 from "./FilterHeader.vue?vue&type=style&index=0&id=37ed7c2b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed7c2b",
  null
  
)

export default component.exports